import { create, v } from '@dojo/framework/core/vdom';
import { logSystem } from '@holmescorp/logger';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
const nls = createNlsMiddleware('settings');
const factory = create({ nls }).properties();
export const Analytics = factory(({ properties, middleware: { nls } }) => {
    const { gtagId: controlledId } = properties();
    window.gtag = function () {
        window.dataLayer?.push(arguments);
    };
    const { messages: { gtagId = '', actOnId = '', actOnPrefix = 'a' } } = nls();
    const gid = controlledId || gtagId;
    return [
        gid
            ? v('script', {
                src: `https://www.googletagmanager.com/gtag/js?id=${gid}`,
                async: true,
                onload: () => {
                    logSystem.info('Google Analytics startup');
                    window.dataLayer = window.dataLayer || [];
                    window.gtag && window.gtag('js', new Date());
                    window.gtag &&
                        window.gtag('config', gid, {
                            page_title: document.title,
                            page_location: location.href,
                            page_path: location.pathname
                        });
                }
            })
            : null,
        actOnId
            ? v('script', {
                src: `https://${actOnPrefix}${actOnId}.actonservice.com/cdnr/forpci85/acton/bn/tracker/${actOnId}`,
                async: true,
                onload: () => {
                    logSystem.info('ActOn Analytics startup');
                    window.ActOn?.Beacon?.track && window.ActOn.Beacon.track();
                }
            })
            : null
    ];
});
export default Analytics;
